<fui-rows [formGroup]="editService.formGroup">
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <wbo-checkbox-edit-control formControlName="deliveryContact" [(ngModel)]="model.data.deliveryContact"></wbo-checkbox-edit-control>
            </fui-column>
            <fui-column>
                <wbo-checkbox-edit-control formControlName="sendSmsOnTakeawayReady" [(ngModel)]="model.data.sendSmsOnTakeawayReady"></wbo-checkbox-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <wbo-textarea-edit-control formControlName="deliveryInstructions"
                                           [(ngModel)]="model.data.deliveryInstructions">
                </wbo-textarea-edit-control>
            </fui-column>
            <fui-column>
                <wbo-textarea-edit-control formControlName="customerNotes"
                                           [(ngModel)]="model.data.customerNotes">
                </wbo-textarea-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
</fui-rows>
